import { render, staticRenderFns } from "./Titulo.vue?vue&type=template&id=f990a3fc&scoped=true&"
import script from "./Titulo.vue?vue&type=script&lang=js&"
export * from "./Titulo.vue?vue&type=script&lang=js&"
import style0 from "./Titulo.vue?vue&type=style&index=0&id=f990a3fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f990a3fc",
  null
  
)

export default component.exports